import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'
import urlSearchParams from '../../components/urlSearchParams'

export const useCompany = () => {
  const [company, setCompany] = useState(false)
  const { deleteNewCompany, getNewCompanies } = useContext(SuperAdminContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Company', 'ALL_COMPANIES', 'GET_ALL_COMPANIES')
  const {
    COMPANY: { GET_ALL_COMPANIES, ADD_COMPANY, EDIT_COMPANY, GET_COMPANY, DELETE_MANY_COMPANY },
  } = API_URL

  const getAllCompany = async (dto = {}) => {
    GET_ALL(GET_ALL_COMPANIES, setPaginate, getNewCompanies, dto)
  }

  const addCompany = (dto) => {
    ADD(ADD_COMPANY, dto, ()=>{}, setCompany)
  }

  const updateCompany = (dto) => {
    UPDATE(EDIT_COMPANY, dto)
  }

  const getCompany = (dto) => {
    GET_SINGLE_DATA(GET_COMPANY, setCompany, urlSearchParams(dto))
  }

  const deleteManyCompany = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_COMPANY, dto, 'companyId', setSelected, deleteNewCompany, 'GET_ALL_COMPANIES')
  }

  return {
    addCompany,
    getAllCompany,
    getCompany,
    company,
    updateCompany,
    deleteManyCompany,
    loading,
    paginate,
  }
}
